import { graphql, useStaticQuery } from "gatsby"

export const useFinanceTeamData = () => {
  const data = useStaticQuery(graphql`
    query {
      allSanityStaff(filter: { tags: { in: "finance-team" } }) {
        nodes {
          id
          tags
          firstname
          lastname
          title {
            en_US
            fr_CA
          }
          photo {
            asset {
              gatsbyImageData(placeholder: BLURRED)
            }
          }
        }
      }
    }
  `)

  return data.allSanityStaff.nodes
}
